import { render } from "./OnBehalfOrder.vue?vue&type=template&id=65d6eb18&scoped=true&ts=true"
import script from "./OnBehalfOrder.vue?vue&type=script&lang=ts"
export * from "./OnBehalfOrder.vue?vue&type=script&lang=ts"

import "./OnBehalfOrder.vue?vue&type=style&index=0&id=65d6eb18&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d6eb18"]])

export default __exports__